import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { CalAngularService } from '@cvx/cal-angular';
import { AppRoleConstants } from '../constants/AppRole.constants';

// Same role the backend GraphPermissionTierReview endpoints require — keeps the page from even
// rendering for anyone who isn't authorized, instead of rendering and letting API calls 403.
export const graphPermissionTierReviewerGuard: CanActivateFn = (route, state) => {
  const calService = inject(CalAngularService);
  return calService.isUserSignedIn() && calService.cvxClaimsPrincipal.roles.some(r => r === AppRoleConstants.ServicePrincipalReadWriteAll)
}
